export function initFaqSectionComponent() {
    const faqAccordion = document.querySelector(".faq-accordion");

    if (faqAccordion) {
        faqAccordion.addEventListener("click", (e) => {
            const questionButton = e.target.closest(".faq-question");
            if (!questionButton) return;

            const currentItem = questionButton.parentElement;
            const isAlreadyActive = currentItem.classList.contains("is-active");

            faqAccordion.querySelectorAll(".faq-item").forEach((item) => {
                if (item !== currentItem) {
                    item.classList.remove("is-active");
                    item.querySelector(".faq-question").setAttribute("aria-expanded", "false");
                }
            });

            if (!isAlreadyActive) {
                currentItem.classList.add("is-active");
                questionButton.setAttribute("aria-expanded", "true");
            } else {
                currentItem.classList.remove("is-active");
                questionButton.setAttribute("aria-expanded", "false");
            }
        });
    }
}
